let category = [
  {
    name: "Women's Fashion",
    subcategory: [
      {
        name: "Clothing",
      },
      {
        name: "Winter Special",
      },
      {
        name: "Muslim Wear",
      },
    ],
  },
  {
    name: "Health & Beauty",
    subcategory: [
      {
        name: "Lingerie",
      },
      {
        name: "Sleep & Lounge",
      },
      {
        name: "Shoes",
      },
    ],
  },
  {
    name: "Women's Fashion2",
    subcategory: [
      {
        name: "Clothing2",
      },
      {
        name: "Winter Special2",
      },
      {
        name: "Muslim Wear2",
      },
    ],
  },
  {
    name: "Health & Beauty2",
    subcategory: [
      {
        name: "Lingerie2",
      },
      {
        name: "Sleep & Lounge2",
      },
      {
        name: "Shoes2",
      },
    ],
  },
];

let colors = [
  {
    name: "red",
    code: "red",
  },
  {
    name: "green",
    code: "green",
  },
  {
    name: "blue",
    code: "blue",
  },
];

let brands = [
  {
    name: "Brand 1",
  },
  {
    name: "Brand 2",
  },
  {
    name: "Brand 3",
  },
];

let prices = [
  {
    name: "$0.00 - $9.99",
  },
  {
    name: "$10.00 - $19.99",
  },
  {
    name: "$20.00 - $29.99",
  },
];

export { category, colors, brands, prices };
